export default class ControlDeviceDto {
    deviceIds: Array<string> = [];//设备id
    tenantId: number;//租户信息
    userName: string;//操作人
    operatorRang: number;//操作范围 0；所有：1；区域：2；户号：3设备
    operatorType: number;//来源数据字典44：抄表；45：开；46：关；78：写底度数；79：写参数；83：下发表计；198：设置上报；199：设置心跳间隔；
    //200：设置上报时间；201：设置设备时间；202：设置设备地址；203：设置网络参数；204：设置设备定时；222：设置密钥;309：设置恶性负载;310:恶性负载跳闸记录
    startTime: string;//开始时间
    isStart: boolean;//是否启动
    sendUnit: number//发送单位，0:分；1、时；2：日；3、月；
    sendCycle: number;//发送周期
    sendRang: number;//发送区间，用于离散时间
    baseUse: number;//底度数
    heartInter: number;//心跳周期
    meterType: number;//表计类型
    sendCode: number;//发送序号
    totalCode: number;//总包数
    thisCode: number;//当前包数
    messageId: number;//消息序号
    imei: string;//设备Imei号
    infoPoint: Array<number> = [];//信息采集点
    dt: number;//信息类标识
    transferType: number;//传输类型
}